import { AppBar, Toolbar, Typography, Box, Avatar } from "@mui/material";

function AppHeader() {
  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{
        background: "#ffffff",
        color: "#1f2937",
        borderBottom: "1px solid #e5e7eb",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img src="/emeis.png" alt="Emeis" height={42} />

          <Box>
            <Typography variant="h6" fontWeight={700}>
              AI Document Verification
            </Typography>

            <Typography variant="caption" color="text.secondary">
              Compliance & Evidence Intelligence
            </Typography>
          </Box>
        </Box>

        <Avatar
          sx={{
            bgcolor: "#f97316",
          }}
        >
          A
        </Avatar>
      </Toolbar>
    </AppBar>
  );
}

export default AppHeader;
